// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { Observable } from 'rxjs';

// Angular Material Files
import { MatDialog } from '@angular/material/dialog';

// Teller Online Files
import { ConfirmDialogComponent, ConfirmDialogData } from 'apps/admin-portal/src/app/shared/components/confirm-dialog/confirm-dialog.component';

// Teller Online Library Files
import { TellerOnlineAppService } from 'teller-online-libraries/core';

export interface FeatureCanDeactivate {
    canDeactivate: (featurePrompt: { message: string, title: string }) => boolean | Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class PendingChangesGuardService {
    constructor(
        private dialog: MatDialog,
        private appService: TellerOnlineAppService
    ) { }

    async canDeactivate(featureComponent: FeatureCanDeactivate): Promise<boolean> {
        const featurePrompt = {
            message: 'You have unsaved changes. Do you want to discard them and leave this page?',
            title: 'Unsaved Changes'
        };

        if (featureComponent) {
            const featureDeactivate = featureComponent.canDeactivate(featurePrompt);
            let canDeactivate: boolean;

            // If there are no pending changes, just allow deactivation; else confirm first
            if (featureDeactivate === true) {
                canDeactivate = true;
            } else {
                // Turn off loading before we prompt or the prompt won't work
                this.appService.finishLoading();

                // Show confirmation dialog
                const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    width: '400px',
                    maxWidth: '90vw',
                    data: {
                        title: featurePrompt.title,
                        message: featurePrompt.message,
                        confirmText: 'Leave Page',
                        cancelText: 'Stay',
                        confirmColor: 'warn'
                    } as ConfirmDialogData
                });

                // Stay and the close icon close with '', a backdrop click or Escape with
                // undefined; the router goes on anything but false, so only Leave Page leaves
                canDeactivate = await dialogRef.afterClosed().toPromise() === true;
            }

            // Turn loading back on if we're leaving
            if (canDeactivate) {
                this.appService.triggerLoading('Loading...');
            }

            return canDeactivate;
        }
        return true;
    }
}
